<div
  *ngIf="otpForm?.controls"
  id="c_{{ componentKey }}"
  class="paper-otp__wrapper {{ config.containerClass }}"
  [ngStyle]="config.containerStyles"
>
  <input
    *ngFor="let item of otpForm?.controls | keys; let i = index"
    id="otp_{{ i }}_{{ componentKey }}"
    maxlength="1"
    class="paper-otp__input {{ config.inputClass }}"
    autocomplete="off"
    numberOnly
    [required]="!isDisabled"
    [attr.inputmode]="config.allowNumbersOnly ? 'numeric' : 'text'"
    [pattern]="config.allowNumbersOnly ? '\\d*' : ''"
    [type]="inputType"
    [placeholder]="config.placeholder || ''"
    [disabledNumberOnly]="!config.allowNumbersOnly"
    [ngStyle]="config.inputStyles"
    [formControl]="$any(otpForm.controls[item])"
    (keydown)="!isDisabled? onKeyDown($event) : false"
    (keyup)="!isDisabled? onKeyUp($event, i) : false"
    (input)="!isDisabled? onInput($event, i) : false"
    [class.valid]="isValid(i)"
    [class.invalid]="isError"
    [class.disabled]="isDisabled"
    [disabled]="isDisabled"
  />
</div>
